module.exports = __webpack_public_path__ + "static/media/destination_turkey.2d966de0.jpg";